export const validatedInputField = {
  data () {
    return {
      currentValue: ''
    }
  },
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'generic' + Math.floor((Math.random() * 1000) + 1000)
    },
    modelValue: {
      required: false,
      default: ''
    },
    errors: {
      type: Object,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    hint: {
      type: String,
      required: false
    },
    showValidationErrors: {
      type: Boolean,
      required: false,
      default: true
    },
    validationParams: {
      type: Object,
      required: false
    },
    validation: {
      type: [Boolean, Object],
      required: false
    },
    validationName: {
      type: String,
      required: false,
      default: 'validation'
    },
    customValidationMessage: {
      type: Object,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    }
  },
  methods: {
    onInput () {
      this.$emit('update:modelValue', this.currentValue)
    },
    onBlur (e) {
      try {
        this.validation.$touch()
      } catch (error) {
      }
      this.$emit('blur')
    }
  },
  created () {
    this.currentValue = this.modelValue
  },
  watch: {
    modelValue (val) {
      this.currentValue = val
    }
  },
  computed: {
    validationErrors () {
      if (!(this.validation && this.validation.$error)) {
        return null
      }

      const buffer = []

      Object.keys(this.validation).forEach((key) => {
        if (!key.startsWith('$') && this.validation[key].$invalid) {
          let translateKeys = Object.assign({ attribute: this.label || this.name }, this.validation[key].$params)

          if (this.validationParams && this.validationParams[key]) {
            translateKeys = Object.assign(translateKeys, this.validationParams[key])
          }

          let message = this.$t(
            `${this.validationName}.${key}`,
            translateKeys
          )

          if (this.customValidationMessage && this.customValidationMessage[key]) {
            message = this.customValidationMessage[key]
          }

          buffer.push({
            type: key,
            message
          })
        }
      })

      return buffer
    }
  }
}

export default validatedInputField
